
// redux
import { useDispatch, useSelector } from 'react-redux';
import { setFinesOffset, setFinesLimit } from 'redux/actions/finesActions';

import { injectIntl, IntlShape } from 'react-intl';

// components
import QueryTableDevices from 'components-lib/QueryTable/QueryTableDevices';

import MDBox from "components/MDBox";

// icon
import ListIcon from '@mui/icons-material/List';

// types
import { PaymentsInOrderData } from 'types/typesRedux';

type Props = {
  intl: IntlShape;
  orderId: number;
  initialRowLimitFines: number;
}

const FinesList = ( { intl, orderId, initialRowLimitFines }: Props ) => {

  const dispatch = useDispatch();

  // redux
  const data = useSelector( (state: any) => state.paymentsInOrder )

  const tableName = intl.formatMessage( {id: 'order.detail.title.fees'} );

  // Handle offset
  const handleOffset = ( tableOffset: number ) => {
    dispatch(setFinesOffset( tableOffset ));
  }
  
  // Handle limit
  const handleLimit = ( tableLimit: number ) => {
    dispatch(setFinesLimit( tableLimit ));
    localStorage.setItem('rowLimitFines', tableLimit.toString());
  }    

  // console.log(data.paymentsInOrder)

  return (
    <MDBox 
      // item xs={12} sm={12} md={12} lg={12}
    >

      <QueryTableDevices
        title= { tableName } 
        tableData={ data.paymentsInOrder }
        pagePagination={true}
        // totalCount={ data.totalCount }
        offset={ 0 }
        rowLimit={ initialRowLimitFines } 
        marginLeft= { false } 
        columns= {[
          // { Header: intl.formatMessage( {id: 'fines.detail.id'} ), 
          // accessor: "id", 
          // width: "auto",
          // minWidth: "3%",
          // columnFilter: 'number',
          // input: 'title',
          // },
          { Header: intl.formatMessage( {id: 'fines.detail.status'} ), 
            accessor: "type", 
            width: "auto",
            minWidth: "9%",
            columnFilter: 'string',
            input: 'title',
          },
          { Header: intl.formatMessage( {id: 'tablePaymentsInOrder.amount'} ), 
            accessor: "amount", 
            width: "auto",
            minWidth: "4%",
            columnFilter: 'string',
            input: 'title',
          },
          { Header: intl.formatMessage( {id: 'tablePaymentsInOrder.description'} ), 
            accessor: "description", 
            width: "auto",
            minWidth: "25%",
            columnFilter: 'string',
            input: 'title',
          },
          { Header: intl.formatMessage( {id: 'tablePaymentsInOrder.status'} ), 
            accessor: "status", 
            width: "auto",
            minWidth: "25%",
            columnFilter: 'string',
            input: 'title',
          },
          ]}
        button={ [{
            add: null ,
            detail: false,
            edit: false,
            delete: false,
            block: false,
        }] }
        icon= { <ListIcon /> }
        onOffset={ handleOffset }
        onLimit={ handleLimit }
        onAddItem={ null }
        onEditBtn={ null }
        onBlockItem={ null }
        onRemoveBtn={ null }
      />

    </MDBox>

  );
};

export default injectIntl(FinesList);